

// kvd
//   JSDataLoopbackRESTAdapterBrowser allows us to:
//     Call Loopback REST backend with the correct parameter formatting..
//
//

import axios  from 'axios'
import { HttpAdapter } from 'js-data-http-node';
import {transform_parameters, LoopbackgetPath} from './JSDataLoopbackUtils'

class JSDataLoopbackRESTAdapterNode extends HttpAdapter
{
    constructor(inOptions?: any){

        var opts = inOptions || {};

        if(!('http' in opts))
        {
            // Create axios 0.15 compatible
            const httpForAdapter = axios.create()
            httpForAdapter.interceptors.request.use(function (config:any) {
                delete config.adapter
                return config
            })

            opts.http = httpForAdapter
        }

        super(opts)
    }

    queryTransform(mapper: any, params:any, opts: any)
    {
        if(Object.keys(params).length == 0)
            return params;

        var loopbackFormat = transform_parameters(params);

        // if all else fails, we could define the config.paramsSerializer..
        // this works for simple foreign keys.
        // move order to top level ?

        return { filter:  loopbackFormat  };

    }

    // Data Loaded through with relationships don't fire the Mapper level After Find.. just the adapter level after find.
    // Responses are not Data Records, they are JSON, therefore it's useless to call the Mapper after call..
    /*
    afterFindAll(mapper: Mapper, query:any, opts:any, response: any) {
        if('afterFindAll' in mapper){
            mapper.afterFindAll(query, opts, response);
        }
    }

    afterFind(mapper: Mapper, id: number|string, opts: any, response: any ){
        if('afterFind' in mapper){
            mapper.afterFind(id, opts, response);
        }
    }
    */

    beforeHTTP(config: any, opts: any)
    {
        //if(opts.op == 'PATCH'){

        //}
    }

    afterHTTP(config: any, opts: any, response: any)
    {

    }

    getPath (method:string, mapper: any, id: number | string, opts: any) {
        return LoopbackgetPath.call(this,method, mapper, id, opts)
    }

    _update (mapper:any, id:any, props:any, opts:any) {
        opts.params = {} //{where: {[mapper.idAttribute]: id}}
        var self = <any>this;

        return self.PATCH(
          self.getPath('update', mapper, id, opts),
          self.serialize(mapper, props, opts),
          opts
        ).then((response:any) => self._end(mapper, opts, response))
    }

    /**
     * Make a PATCH request.
     *
     * @name HttpAdapter#POST
     * @method
     * @param {*} url The url for the request.
     * @param {Object} data Payload for the request.
     * @param {Object} config Request configuration options.
     * @param {Object} [opts] Configuration options.
     * @return {Promise}
     */
    PATCH(url:string, data:any, config:any, opts:any) {
        var _this16:any = this;

        var op:any = void 0;
        config || (config = {});
        opts || (opts = {});
        config.url = url || config.url;
        config.data = data || config.data;
        config.method = config.method || 'patch';

        op = opts.op = 'PATCH';
        _this16.dbg(op, url, data, config, opts);
        return _this16.HTTP(config, opts);
    }

};

export {JSDataLoopbackRESTAdapterNode}


